function pageNotFound() {
  return (
    <div className="min-h-screen bg-zinc-900">
      <div className="grid items-start justify-center py-56 text-white">
        <h1 className="text-6xl">Error 404:</h1>
        <h2 className="text-3xl">Page not found</h2>
      </div>
    </div>
  );
}

export default pageNotFound;
